import { render, staticRenderFns } from "./GtsInfoWidgetWBorder.vue?vue&type=template&id=4dccfe94&scoped=true"
import script from "./GtsInfoWidgetWBorder.vue?vue&type=script&lang=js"
export * from "./GtsInfoWidgetWBorder.vue?vue&type=script&lang=js"
import style0 from "./GtsInfoWidgetWBorder.vue?vue&type=style&index=0&id=4dccfe94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dccfe94",
  null
  
)

export default component.exports